import { Component, OnInit, OnDestroy } from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {ShareService } from './../services/services';
import {News,NewsService } from './news.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title } from '@angular/platform-browser';

interface PageData {
  title: string;
  description: string;
  meta_title: string;
  meta_description: string;
  
  
  
}


let bigtos_pluugging = document.querySelector('bigtos');
let plugging = bigtos_pluugging ? bigtos_pluugging.innerHTML : "";

let componentmodel;

if(plugging.length)
{
    
   
    let jsonObject : any = JSON.parse(plugging)
    //console.log("hotel:->"+JSON.stringify(jsonObject));
    
    if(jsonObject.news)
    {
	    componentmodel=true;
    }
    else
    {
	    componentmodel=false;
    }
}
//console.log("hoteldata"+hotemodel);
let componentdata;
if(componentmodel)
{
   componentdata={selector: 'news',templateUrl: './pg/news/newshome.component.html'}
}
else
{
   componentdata={selector: 'news',template: '<div></div>'}

   
}

@Component(componentdata)
/*
@Component({
    selector: 'news',
	//template: require('./news.component.html')
	//templateUrl: './pg/news/newshome.component.html'
	templateUrl: './pg/news/newshome.component.html'
	
	
})*/

export class NewsHomeComponent implements OnInit {
	
	
	pagedata: PageData;
	public headingtitle;
	private _sub: Subscription;
	public metatitle;
    public metadescription;
    
    public category; 
    public news:Array<any>;
	constructor(
	    private http: Http,
	    private _route: ActivatedRoute,
	    private _router: Router,
	    private shareService: ShareService,
	    private _title: Title,
	    private _pageService: NewsService) {
		   
		   this.pagedata = {
                  title:'',                  
                  description: '',
                  meta_title: '',
                  meta_description: ''
                 
				  	}		  
	    }
	    

	ngOnInit() {
	    // this.pagedata.description="umesh naga";
	    //  this.pagedata.slug="umesh naga";
	    
	  this._sub = this._route.params.subscribe(params => {
			
						 //  console.log(slug);
			   //this._applicationService.doLogin().subscribe	      
			   //this._pageService.getPage(slug);
			   
			  let limit="8";
			let compservice=document.querySelector('news');
			if(compservice){
			if(compservice.getAttribute('limit'))
			{
				limit=compservice.getAttribute('limit');
			}
			} 			   
			   
			   this._pageService.getLatestNews(limit).subscribe(
        data => {
                              
                                  
                  this.news=data.news;
                  this.headingtitle=data.menu.link_showing_name;                 
                  //$window.document.title ='someTitleYouCreated' ;
                  //console.log(this.pagedata.title);                               
              
           
        },
        err => console.error(err),
        () => console.log('services completed')
    );
			   
			   
			   
			   
			   
			   		   
		}); 
		
	
		
	}

    ngOnDestroy() {
       this._sub.unsubscribe();
    }

}


// WEBPACK FOOTER //
// ./resources/assets/typescript/news/newshome.component.ts